<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option value>全部</a-select-option>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分区选择">
              <a-tree-select :tree-data="zoneTreeData" v-model="query.zoneId" style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
                :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search
                treeNodeFilterProp="title"></a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水表编号">
              <a-input clearable v-model="query.waterMeterNumber" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="downloadTemplate({ execlForm: true })"
                v-action:upload>下载模板</a-button>
              <a-upload name="file" :multiple="false" @change="changeFile" :file-list="fileList"
                :customRequest="customRequest">
                <a-button style="margin-left: 8px" type="primary" :loading="exportLoading" v-action:import>导入</a-button>
              </a-upload>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="oldZoneId" bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <template slot="value" slot-scope="text, record">
        <div v-html="textreplace(text)"></div>
      </template>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal title="操作" style="top: 20px" :width="800" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="区域id" hidden>
          <a-input v-decorator="['oldZoneId']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">
          <a-tree-select :tree-data="zoneTreeData"
            v-decorator="['zoneId', { rules: [{ required: true, message: '请选择片区' }] }]" style="width: 100%"
            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
            :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search treeNodeFilterProp="title"></a-tree-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计算规则">
          <a-textarea placeholder="计算规则" :rows="4"
            v-decorator="['value', { rules: [{ required: true, message: '请输入计算规则' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="步长">
          <a-select placeholder="请输入步长" v-decorator="['stepSize']" >
            <a-select-option value="5分钟">5分钟</a-select-option>
            <a-select-option value="15分钟">15分钟</a-select-option>
            <a-select-option value="30分钟">30分钟</a-select-option>
            <a-select-option value="1小时">1小时</a-select-option>
            <a-select-option value="一天">一天</a-select-option>
            <a-select-option value="一月">一月</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'

const columns = [
  {
    title: '区域名称',
    dataIndex: 'zoneName'
  },
  // {
  //   title: 'label',
  //   dataIndex: 'label'
  // },
  // {
  //   title: '计算排序',
  //   dataIndex: 'sort'
  // },
  {
    title: '计算规则',
    dataIndex: 'value',
    scopedSlots: { customRender: 'value' }

  },
  {
    title: '步长',
    dataIndex: 'stepSize',
    scopedSlots: { customRender: 'stepSize' }

  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'MenuList',
  data () {
    return {
      fileList: [],
      queryUrl: '/zone-metering/calculate-rule',
      addOrUpdateUrl: 'zone-metering/calculate-rule',
      deleteUrl: 'zone-metering/calculate-rule',
      exportDataUrl: 'manager/configs/export',
      downloadTemplateUrl: 'pipe-network/calculate-rule/template/download',
      downloadTemplateName: '各片区关联水表导入模板.xlsx',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      query: {
        zoneId: '',
        tenantId: this.$store.state.user.info.tenantId,
        waterMeterNumber: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      zoneTreeData: [], // 片区选项
      oldZoneId: '',
      treeDefaultExpandedKeys: [],//默认展开的树节点	
      tenantList: [], // 水司数据选择
      waterMeterNumber: '',
    }
  },
  filters: {
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  created () {
    this.getZoneData(),
      this.getAllTenant()
    this.resetList()
  },
  methods: {
    textreplace (text) {
      return text.replace(/\+/g, '<span style="color:#2f54eb">✚ </span>').replace(/-/g, '<span style="color:red"> ━ </span> ')
    },
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRowKeys = []
      this.queryList()
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
        this.chuli(this.zoneTreeData)

      })
    },
    chuli (n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {

          item.children = this.chuli(item.children)
          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    changeFile (info) {
      // 上传文件
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} 上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    customRequest (data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile (formData) {
      this.exportLoading = true
      this.axios({
        method: 'post',
        url: '/zone-metering/calculate-rule/import',
        headers: {},
        params: {},
        data: formData
      })
        .then((response) => {
          if (response.code === 0) {
            this.queryList()
            this.$message.success(response.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    addOrUpdateHandle (record) {
      console.log(record);

      this.isUpdate = false
      this.currentId = record ? record.id : ''
      console.log(this.currentId);

      // this.query.zoneId = record ? record.zoneId : ''
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (record) {
        this.isUpdate = true
        this.oldZoneId = record.oldZoneId
        this.$nextTick(() => {
          this.addOrUpdateForm.setFieldsValue(record)
        })

        console.log(record)
      }
    },
    getAllTenant () {
      if (this.$store.state.user.info.systemAdmin) {
        this.$http
          .get('/manager/tenants/all')
          .then(({ data }) => {
            this.tenantList = data
          })
          .catch(({ e }) => {
            console.log(e)
          })
      }
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
